exports.default = [
  /*{
    defaultImageUrl: '/portfolio/sur-mesure/default.jpg',
    title: 'Fabrication sur mesure',
    to: '/realisations/sur-mesure'
  },*/
  {
    defaultImageUrl: '/portfolio/cuisine/default.jpg',
    title: 'Cuisine',
    to: '/realisations/cuisine',
    meta: {
      title: 'Cuisine customisée, avec façades et finitions faites à la main',
      description: 'Réalisation de votre cuisine sur mesure avec une parfaite de maitrise de votre budget.'
    }
  },
  {
    defaultImageUrl: '/portfolio/salle-de-bain/default.jpg',
    title: 'Salle de bain',
    to: '/realisations/salle-de-bain',
    meta: {
      title: 'Fabrication de votre salle de bain en mélaminé hydrofuge',
      description: 'Utilisation des meilleurs matériaux hydrofuges pour une parfaite fabrication de votre salle de bain sur mesure.'
    }
  },
  {
    defaultImageUrl: '/portfolio/bibliotheque/default.jpg',
    title: 'Bibliothèque',
    to: '/realisations/bibliotheque',
    meta: {
      title: 'Bibliothèques et placards sur mesure, selon vos envies',
      description: 'Nous réalisons la bibliothèque de vos rêves dans un budget maîtrisé.'
    }
  },
  {
    defaultImageUrl: '/portfolio/dressing/default.jpg',
    title: 'Dressing placard',
    to: '/realisations/dressing-placard',
    meta: {
      title: 'Rangements et dressing sur mesure pour optimiser votre espace',
      description: 'Nous optimisons votre espace de manière fonctionnelle pour un espace de rangement ou un dressing sur mesure.'
    }
  },
  {
    defaultImageUrl: '/portfolio/tete-de-lit/default.jpg',
    title: 'Tête de lit',
    to: '/realisations/tete-de-lit',
    meta: {
      title: 'Tête de lit sur mesure avec lumière et rangements à façon',
      description: 'Nous apportons une touche personnalisée à votre chambre et à votre intérieur avec des habillages sur mesure.'
    }
  },
  {
    defaultImageUrl: '/portfolio/parquet/default.jpg',
    title: 'Parquet',
    to: '/realisations/parquet',
    meta: {
      title: 'Parquet sur mesure (choix du bois et de la technique de pose)',
      description: 'Nous créons sur mesure votre parquet avec le bois et la technique de pose souhaitée pour un sol aussi beau que résistant.'
    }
  },
  {
    defaultImageUrl: '/portfolio/terrasse/default.jpg',
    title: 'Terrasse',
    to: '/realisations/terrasse',
    meta: {
      title: 'Fabrication, pose et habillage de toutes vos terrasses',
      description: 'Nous donnons une autre dimension à votre jardin avec nos terrasses sur mesure pour en profiter toute l’année.'
    }
  },
  {
    defaultImageUrl: '/portfolio/sur-mesure/default.jpg',
    title: 'Divers et sur-mesure',
    to: '/realisations/divers',
    meta: {
      title: 'Réalisation de vos envies les plus folles pour un intérieur hors norme',
      description: 'Nous mettons tout notre savoir faire menuisier et toutes nos astuces pour vos réalisations les plus atypiques.'
    }
  },
  {
    defaultImageUrl: '/portfolio/ebenisterie/default.jpg',
    title: 'Ébenisterie',
    to: '/realisations/ebenisterie',
    meta: {
      title: 'Les plus belles essences et les plus beaux bois pour créer votre meuble intemporel',
      description: 'Nous fabriquons des plus belles pièces de votre intérieur, pour toute une vie.'
    }
  },
  {
    defaultImageUrl: '',
    title: 'Habillage escalier',
    to: '/realisations/escalier',
    hide: true,
    meta: {
      title: '',
      description: ''
    }
  }
]



// WEBPACK FOOTER //
// ./src/data.js